import Swal from "sweetalert2";

async function showCommonPaymentConfirmation(linkCount, vendorName) {
    const result = await Swal.fire({
        title: "Create Common Payment Link",
        html: `
            <div style="font-size: 15px;">
                You are combining <b>${linkCount}</b> payment links into a single vendor payment link for <b>${vendorName}</b>.
                <br/><br/>
                Would you like to proceed?
            </div>
        `,
        icon: 'question',
        showCancelButton: true,
        showDenyButton: true,

        cancelButtonText: 'Cancel',
        denyButtonText: 'Proceed without GST',
        confirmButtonText: 'Proceed with GST',

        confirmButtonColor: "#2e7d32",
        denyButtonColor: "#1565c0",
        cancelButtonColor: "#6b7280",

        reverseButtons: true
    });

    if (result.isConfirmed) {
        return {
            proceed: true,
            isGst: true
        }
    }

    if (result.isDenied) {
        return {
            proceed: true,
            isGst: false
        }
    }

    return {
        proceed: false
    }
}

const CustomConfirms = {
    showCommonPaymentConfirmation
}

export default CustomConfirms;